import styled from '@emotion/styled';

const StyledCheckBox = styled.input({
  marginRight: '15px',
  display: 'none',
});

export default StyledCheckBox;
